import { NewsType } from "../domain/News";
import { CCEALogo } from "./images/CceaLogo";
import { OfqualLogo } from "./images/OfqualLogo";

export const getLogo = (type: NewsType) => {
  switch (type) {
    case NewsType.Ofqual:
      return <OfqualLogo />;
    case NewsType.CceaRegulator:
      return <CCEALogo />;
    default:
      return null;
  }
};
